export default {
  title: '素材空间',
  fileUsage: '文件数量',
  allMaterials: '全部素材',
  images: '图片',
  videos: '视频',
  selectAll: '全选',
  newFolder: '新建文件夹',
  localUpload: '本地上传',
  addFolder: '+新增文件夹',
  referenced: '已被引用',
  delete: '删除',
  productMainImage: '商品主图',
  newFolderTitle: '新建文件夹',
  parentFolder: '所属上级文件夹',
  pleaseSelect: '请选择',
  folderName: '新建文件夹名称',
  folderNamePlaceholder: '请输入文件夹名称',
  confirm: '确定',
  cancel: '取消',
  uploadTitle: '上传图片/视频',
  selectFile: '选择文件',
  uploadPreview: '上传预览',
  selectFolder: '选择文件夹',
  closeGallery: '关闭素材空间',
  useSelectedImages: '使用选中图片',
  useSelectedVideos: '使用选中视频',
  deleteConfirm: '确定删除选中的文件吗？',
  deleteSuccess: '删除成功',
  deleteFailed: '删除失败',
  createFolderSuccess: '文件夹创建成功',
  createFolderFailed: '文件夹创建失败',
  folderNameRequired: '请输入文件夹名称',
  noFileSelected: '请选择文件',
  uploadSuccess: '上传成功',
  uploadFailed: '上传失败',
  renameFolder: '重命名',
  deleteFolder: '删除文件夹',
  renameFolderTitle: '重命名文件夹',
  newFolderNameLabel: '新名称',
  newFolderNamePlaceholder: '请输入新的文件夹名称',
  renameFolderSuccess: '重命名成功',
  renameFolderFailed: '重命名失败',
  deleteFolderConfirm: '确定删除该文件夹吗？删除后文件夹内的文件将移至默认目录。',
  deleteFolderSuccess: '文件夹删除成功',
  deleteFolderFailed: '文件夹删除失败',
  preview: '预览',
  deleteFileConfirm: '确定删除该文件吗？',
  deleteFileSuccess: '文件删除成功',
  deleteFileFailed: '文件删除失败',
  uploadFormatNotSupported: '不支持的格式：{names}，仅支持 JPG / PNG / JPEG',
  uploadBatchLimitExceeded: '单次最多上传 {max} 个文件，请分批上传',
  uploadAllowedFormatsTip: '仅支持 JPG / PNG / JPEG 格式，单次最多 {max} 张',
  uploadFormatNotSupportedSimple: '不支持的格式，仅支持 JPG / PNG / JPEG',
  selectionLimitReached: '最多选择 {max} 张图片',
  selectedCount: '已选 {n} / {max}',
  referencedItemNotSelectable: '该素材已被引用，无法选择',
  loadingMore: '加载中…',
  noMore: '已显示全部 {n} 项',
  shownProgress: '已显示 {shown} / {total}',
  pickerImageDialogTitle: '选择图片',
  pickerVideoDialogTitle: '选择视频'
}
